import React from 'react';
import styles from './bdroLoginError.module.css';
export var BdroLoginError = function (_a) {
    var text = _a.text;
    if (!text) {
        return null;
    }
    return React.createElement("div", { className: styles.BdroAlertError }, text);
};
